import _ from 'lodash';

export function copyObj<T>(obj: T): T {
  return _.cloneDeep(obj);
}
